import { defineMessages } from 'react-intl';

export const i18n: {
	caseStatusFilterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	caseStatusFilterNoOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	caseStatusFilterLabel: {
		id: 'search-page.salesforce.filter.caseStatus',
		defaultMessage: 'Case status',
		description: 'Label for filtering by Salesforce case status',
	},
	caseStatusFilterNoOptions: {
		id: 'search-page.salesforce.filter.caseStatus.no-options',
		defaultMessage: 'No statuses available',
		description:
			'Message shown in the Salesforce case status filter dropdown when no status options are available',
	},
});
